'use client';

import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/auth-context';
import { useEchoConnection } from '@/hooks/use-echo-connection';

import { ocrApi } from '../services/ocr.api';
import { ocrKeys } from '../services/ocr.queries';

const FALLBACK_POLL_MS = 10_000;

/**
 * Active in-flight OCR jobs for the current user. WebSocket is the primary
 * transport — when the connection degrades, falls back to lightweight polling.
 */
export function useActiveOcrJobs() {
  const { user, status } = useAuth();
  const { shouldFallback } = useEchoConnection();
  const enabled = status === 'authenticated' && !!user?.id;

  return useQuery({
    queryKey: ocrKeys.activeJobs(),
    queryFn: () => ocrApi.activeJobs(),
    enabled,
    refetchInterval: shouldFallback ? FALLBACK_POLL_MS : false,
    refetchOnWindowFocus: true,
    staleTime: shouldFallback ? FALLBACK_POLL_MS / 2 : 30_000
  });
}
